// SHIPPING FILTER  ACTIONS:
export const SET_FROM_MAPPING           = "SET_FROM_MAPPING";
export const SET_RESOURCES_LIST         = "SET_RESOURCES_LIST";
export const UPDATE_FROM_MAPPING_FIELDS ="UPDATE_FROM_MAPPING_FIELDS";
export const REMOVE_FROM_MAPPING_FIELD  = "REMOVE_FROM_MAPPING_FIELD";
export const SET_TO_PAGES               = "SET_TO_PAGES";
export const SET_TO_MAPPING             = "SET_TO_MAPPING";
export const UPDATE_TO_MAPPING_FIELDS   = "UPDATE_TO_MAPPING_FIELDS";
export const REMOVE_TO_MAPPING_FIELD    = "REMOVE_TO_MAPPING_FIELD";
export const SET_TO_PAGE_CONDITION      = "SET_TO_PAGE_CONDITION";
export const CLEAR_PAGES_CONFIG         = "CLEAR_PAGES_CONFIG";
export const REMOVE_TO_PAGES            = "REMOVE_TO_PAGES";

export const LOAD_CONFIG_COLLECTION     = "LOAD_CONFIG_COLLECTION";
export const SET_ACTIVE_CONFIG_PAGE     = "SET_ACTIVE_CONFIG_PAGE";
export const REMOVE_ACTIVE_POPUP_PAGE   = "REMOVE_ACTIVE_POPUP_PAGE";
export const SET_RESOURCES_LIST_BY_TYPE = "SET_RESOURCES_LIST_BY_TYPE";
export const UPDATE_PAGE_FLOWS_DATA     = "UPDATE_PAGE_FLOWS_DATA";
export const RESTORE_PAGE_FLOWS         = "RESTORE_PAGE_FLOWS";

export const SET_HISTORY_PAGE_FLOWS     = "SET_HISTORY_PAGE_FLOWS";
export const GO_TO_HISTORY_PAGE_FLOWS   = "GO_TO_HISTORY_PAGE_FLOWS";
// export const LOAD_CONFIG_COLLECTION     = "LOAD_CONFIG_COLLECTION";